import React from 'react'
import PropTypes from 'prop-types'
import styled from '@emotion/styled'
import { css } from '@emotion/react'
import { mobile, tablet } from '~styles/global'
import Section from '~components/Section'
import ProductTile from '~components/ProductTile'

const ProductGrid = ({ className, products }) => {
	return (
		<Wrap className={className} >
			{products?.map(p => (
				<ProductTile key={p.store?.title} product={p}/>
			))}
		</Wrap>
	)
}

const Wrap = styled(Section)`	
	>div{
		grid-row-gap: var(--xxl);
	}
`

ProductGrid.propTypes = {
	className: PropTypes.string,
	products: PropTypes.array,
}

export default ProductGrid